import { Group as ApiGroup } from 'api/groupAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../../actions/groupDashboard/groups';

export type Group = ApiGroup & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, Group>;
};
export default function groups(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_FETCH_GROUP_REQUEST':
      return {
        byId: {
          ...state.byId,
          [action.groupId]: {
            ...state.byId[action.groupId],
            id: action.groupId,
            isFetching: true,
          },
        },
      };

    case 'GROUP_DASHBOARD_FETCH_GROUP_SUCCESS':
      return {
        byId: {
          ...state.byId,
          [action.group.id]: { ...action.group, isFetching: false },
        },
      };

    case 'GROUP_DASHBOARD_DELETE_GROUP': {
      const newState = { ...state };
      delete newState.byId[action.groupId];
      return newState;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
